import { useEffect, useState } from "react";

const Bullets = () => {
    const [index, setIndex] = useState(0);

    const scroll = (key) => {
        const element = document.getElementById(key);
        element.scrollIntoView()
    }

    const scrollMatch = (key) => {
        switch (key) {
            case 0:
                scroll('hero')
                break;
            case 1:
                scroll('movie__vote1')
                break;
            case 2:
                scroll('movie__vote2')
                break;
            case 3:
                scroll('movie__vote3')
                break;
            case 4:
                scroll('movie__vote4')
                break;
            case 5:
                scroll('movie__vote5')
                break;
            default:
                break;
        }
        setTimeout(() => {
            setIndex(key)
        }, 1000);
    }

    useEffect(() => {
        setInterval(() => {
            const hero = document.getElementById('hero').getBoundingClientRect();
            const react1 = document.getElementById('movie__vote1').getBoundingClientRect();
            const react2 = document.getElementById('movie__vote2').getBoundingClientRect();
            const react3 = document.getElementById('movie__vote3').getBoundingClientRect();
            const react4 = document.getElementById('movie__vote4').getBoundingClientRect();
            const react5 = document.getElementById('movie__vote5').getBoundingClientRect();
            if (hero.top === 0) {
                setIndex(0);
            } else if (react1.top === 0) {
                setIndex(1)
            } else if (react2.top === 0) {
                setIndex(2)
            } else if (react3.top === 0) {
                setIndex(3)
            } else if (react4.top === 0) {
                setIndex(4)
            } else if (react5.top === 0) {
                setIndex(5)
            }
        }, 50);
    }, [])

    return (
        <div className={`movie__radio__wrapper ${index === 0 && 'movie__radio__wrapper__none'}`}>
            <p
                onClick={() => scrollMatch(0)}
                className={`movie__home`}>
                <i className="fa fa-home"></i>
            </p>
            {Array(5).fill().map((_, i) => (
                <p
                    onClick={() => scrollMatch(i + 1)}
                    className={`movie__radio ${i + 1 === index && 'active'}`}>
                    <p></p>
                </p>
            ))}
        </div>
    )
}

export default Bullets